import Vue from "vue";
import {
  TOOLTIP_VISIBLE,
  TOOLTIP_CURRENT_ID,
  TOOLTIP_CURRENT_STEP,
  TOOLTIP_GUIDANCE_ENABLED,
  TOOLTIP_COMPLETED,
  TOOLTIP_DISMISSED,
  SET_TOOLTIP_VISIBILITY,
  SET_TOOLTIP_CURRENT,
  SET_TOOLTIP_STEP,
  COMPLETE_TOOLTIP,
  SKIP_TOOLTIP,
  SET_USER_PREFERENCES,
  TOOLTIP_PREFERENCES_KEY,
  COMPLETED_TOURS_KEY,
  DISMISSED_TOOLTIPS_KEY
} from "./constants";
import { TooltipModuleState, SetTooltipVisibilityPayload, CompleteTooltipPayload, SkipTooltipPayload } from "./interfaces";

export default {
  [SET_TOOLTIP_VISIBILITY](state: TooltipModuleState, payload: SetTooltipVisibilityPayload): void {
    state.tooltips.active = payload.visible;
    
    if (payload.tooltipId) {
      state.tooltips.currentTooltipId = payload.visible ? payload.tooltipId : null;
      state.tooltips.currentStep = 0;
    }
  },

  [SET_TOOLTIP_CURRENT](state: TooltipModuleState, payload: SetTooltipVisibilityPayload): void {
    state.tooltips.currentTooltipId = payload.tooltipId || null;
    state.tooltips.currentStep = 0;
  },

  [SET_TOOLTIP_STEP](state: TooltipModuleState, step: number): void {
    state.tooltips.currentStep = step;
  },

  [COMPLETE_TOOLTIP](state: TooltipModuleState, payload: CompleteTooltipPayload): void {
    if (!state.userPreferences.completedTours.includes(payload.tooltipId)) {
      state.userPreferences.completedTours.push(payload.tooltipId);
      
      // Save to localStorage
      localStorage.setItem(COMPLETED_TOURS_KEY, JSON.stringify(state.userPreferences.completedTours));
    }
    
    state.tooltips.active = false;
    state.tooltips.currentTooltipId = null;
    state.tooltips.currentStep = 0;
  },

  [SKIP_TOOLTIP](state: TooltipModuleState, payload: SkipTooltipPayload): void {
    if (!state.userPreferences.dismissedTooltips.includes(payload.tooltipId)) {
      state.userPreferences.dismissedTooltips.push(payload.tooltipId);
      
      // Save to localStorage
      localStorage.setItem(DISMISSED_TOOLTIPS_KEY, JSON.stringify(state.userPreferences.dismissedTooltips));
    }
    
    state.tooltips.active = false;
    state.tooltips.currentTooltipId = null;
    state.tooltips.currentStep = 0;
  },

  [SET_USER_PREFERENCES](state: TooltipModuleState, preferences: Partial<TooltipModuleState['userPreferences']>): void {
    if (preferences.firstRun !== undefined) {
      state.userPreferences.firstRun = preferences.firstRun;
    }
    if (preferences.completedTours) {
      state.userPreferences.completedTours = preferences.completedTours;
    }
    if (preferences.dismissedTooltips) {
      state.userPreferences.dismissedTooltips = preferences.dismissedTooltips;
    }
    
    // Save entire preferences to localStorage
    localStorage.setItem(TOOLTIP_PREFERENCES_KEY, JSON.stringify(state.userPreferences));
  },

  [TOOLTIP_VISIBLE](state: TooltipModuleState, visible: boolean): void {
    state.tooltips.active = visible;
  },

  [TOOLTIP_CURRENT_ID](state: TooltipModuleState, tooltipId: string | null): void {
    state.tooltips.currentTooltipId = tooltipId;
  },

  [TOOLTIP_CURRENT_STEP](state: TooltipModuleState, step: number): void {
    state.tooltips.currentStep = step;
  },

  [TOOLTIP_GUIDANCE_ENABLED](state: TooltipModuleState, enabled: boolean): void {
    state.tooltips.showGuidance = enabled;
  },

  [TOOLTIP_COMPLETED](state: TooltipModuleState, completedTooltips: string[]): void {
    state.tooltips.completedTooltips = completedTooltips;
    state.userPreferences.completedTours = completedTooltips;
  },

  [TOOLTIP_DISMISSED](state: TooltipModuleState, dismissedTooltips: string[]): void {
    state.userPreferences.dismissedTooltips = dismissedTooltips;
  }
};
